const DRAWER_ITEMS = [
  { id: "perfil", key: "tabPerfil", icon: "user" },
  { id: "meubairro", key: "tabMeuBairro", icon: "map" },
  { id: "comunidades", key: "tabComunidades", icon: "users" },
  { id: "notificacoes", key: "tabNotificacoes", icon: "bell" },
  { id: "alertas", key: "tabAlertas", icon: "shield" },
  { id: "ajuda", key: "tabAjuda", icon: "circle-help" },
];

function SideDrawer({ lang, open, onClose, tab, onNavigate, profile, unreadNotifCount }) {
  const { Icon } = window.VigiALDesignSystem_ff2dec;
  if (!open) return null;

  return (
    <div style={{ position: "absolute", inset: 0, zIndex: 45, display: "flex" }}>
      <div
        className="vigi-drawer-scrim"
        onClick={onClose}
        style={{ position: "absolute", inset: 0, background: "var(--overlay-scrim)" }}
      />
      <div
        className="vigi-drawer-panel"
        style={{
          position: "relative", width: 236, height: "100%", background: "var(--color-surface)",
          borderRight: "1px solid var(--color-border)", boxShadow: "var(--shadow-modal)",
          display: "flex", flexDirection: "column",
        }}
      >
        <div style={{ padding: "18px 16px 14px", borderBottom: "1px solid var(--color-border)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 9, minWidth: 0 }}>
            {window.AvatarBadge ? <window.AvatarBadge avatar={profile && profile.avatar} size={32} /> : (
              <div style={{ width: 32, height: 32, borderRadius: "50%", background: "var(--color-brand-tint)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <Icon name="user" size={16} color="var(--color-brand-deep)" />
              </div>
            )}
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: "var(--text-sm)", fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {profile ? (profile.username || profile.name) : t(lang, "menuGuest")}
              </div>
              {window.isPremium && window.isPremium() && (
                <div style={{ fontSize: "var(--text-xs)", color: "var(--color-brand-primary)", fontWeight: 600 }}>{t(lang, "planPremium")}</div>
              )}
            </div>
          </div>
          <button onClick={onClose} style={{ background: "transparent", border: "none", cursor: "pointer", padding: 4, flexShrink: 0, display: "flex" }}>
            <Icon name="x" size={18} color="var(--color-text-muted)" />
          </button>
        </div>

        <div style={{ padding: "10px 8px", flex: 1 }}>
          {DRAWER_ITEMS.map((it) => {
            const active = tab === it.id;
            return (
              <button
                key={it.id}
                onClick={() => onNavigate(it.id)}
                style={{
                  width: "100%", display: "flex", alignItems: "center", gap: 10, padding: "10px 10px", borderRadius: 9, marginBottom: 4,
                  background: active ? "var(--color-brand-tint)" : "transparent", border: "none", cursor: "pointer",
                  fontFamily: "var(--font-body)", textAlign: "left",
                }}
              >
                <div style={{ position: "relative", display: "flex", flexShrink: 0 }}>
                  <Icon name={it.icon} size={17} color={active ? "var(--color-brand-deep)" : "var(--color-text-secondary)"} />
                  {it.id === "notificacoes" && unreadNotifCount > 0 && (
                    <span style={{
                      position: "absolute", top: -5, right: -6, minWidth: 14, height: 14, borderRadius: 7,
                      background: "var(--color-alert)", color: "#fff", fontSize: 9, fontWeight: 700,
                      display: "flex", alignItems: "center", justifyContent: "center", padding: "0 3px", lineHeight: 1,
                    }}>
                      {unreadNotifCount > 9 ? "9+" : unreadNotifCount}
                    </span>
                  )}
                </div>
                <span style={{ fontSize: "var(--text-sm)", fontWeight: active ? 600 : 400, color: active ? "var(--color-brand-deep)" : "var(--color-text-primary)" }}>
                  {t(lang, it.key)}
                </span>
              </button>
            );
          })}
        </div>

        <div style={{ padding: "10px 16px 14px", fontSize: "var(--text-xs)", color: "var(--color-text-muted)", borderTop: "1px solid var(--color-border)" }}>
          Alerta AL · {t(lang, "appTagline")}
        </div>
      </div>
    </div>
  );
}
window.SideDrawer = SideDrawer;
